module.exports = __webpack_public_path__ + "static/media/SLB.1c927e1c.png";